<div class="side-panel-title-container">
    @switch(page) {
        @case (sidePanelPages.HOMEPAGE) {
            <p>Scegli il tipo di ricerca</p>
        }
        @case (sidePanelPages.DIRECTSEARCH) {
            <p>Ricerca diretta</p>
        }
        @case (sidePanelPages.PREGUIDEDSEARCH) {
            <p>Ricerca guidata</p>
        }
        @case (sidePanelPages.SURVEY) {
            <p>Ricerca guidata</p>
        }
        @case (sidePanelPages.INSURANCEPAGE) {
            <p>Dettaglio polizza</p>
        }
        @default {
            <p><b>Comparatore</b></p>
        }
    }
</div>